import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Stack, Snackbar, Alert } from '@mui/material';
import {Grid, Button, Box} from '@material-ui/core';
import { DataGrid } from '@mui/x-data-grid';
import Tooltip from '@mui/material/Tooltip';
import Radio from '@mui/material/Radio';
import axios from 'axios';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';

import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import {API_URL} from '../utils/EnvVars';
import 'font-awesome/css/font-awesome.min.css';

var vertical='top',horizontal='center';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => { 
  const [open, setOpen] = React.useState(false); 
  const [rows, setRows] = React.useState([]);
  const [selectedRow, setSelectedRow] = React.useState(0);

  const alphaArr = ['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
	const alphaBtnStyle = {marginTop:-10,marginBottom:5,padding:0,display: 'inline-block', minHeight: 30, minWidth: 30, marginRight:5};
	const alphaBtnStyleActive = {marginTop:-10,marginBottom:5,padding:0,display: 'inline-block', minHeight: 30, minWidth: 30, marginRight:5, backgroundColor:'#0c65d8', color:'#FFFFFF'};

	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");

  //const [dataLoading, setDataLoading] = React.useState(true);
	const [filter, setFilter] = React.useState(false);
	const [keyword, setKeyword] = React.useState("");
  const [alphaFilter, setAlphaFilter] = React.useState("");

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function selectRow(obj){
		if(obj && rows[obj.id-1]){			
			setSelectedRow(rows[obj.id-1].id);
			props.contactDetail(rows[obj.id-1]);
      setOpen(false);
		}
	}

  function search(){
    setAlphaFilter("");
		setFilter(!filter);
	}

	function onEnter(event){
		if(event.key === 'Enter'){
			setFilter(!filter);
		}
	}

  function handleAlphaFilter(val){
		setAlphaFilter(val);
		setFilter(!filter);
	}

  React.useEffect(() => {		
		if(open && props.userObj){
			getApiData();
		}
	}, [props.userObj,filter,open]);

	async function getApiData(){ 
		  let apiUrl=API_URL+'/crm-list-contacts?keyword='+keyword+'&alphaFilter='+alphaFilter;
		  let axiosHeader = {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': props.userObj.registerId,
					'uid': props.userObj.loginId,
					'fullName': props.userObj.fullName,
					'token': props.userObj.token,
			};
			const config = {
				method: 'get',
				url: apiUrl,
				headers: axiosHeader
			}
			await axios(config)
			   .then(response => {
				//setDataLoading(false);
				if(response && response.data && response.data.responseTxt==="success"){  
				 	setRows(response.data.list);				 				
				}else if(response && response.data && response.data.responseTxt==="invalidtoken"){
					window.location.href='invalidtoken';
				}
			}).catch((error) => {
				  setSeverityAlert("error");
				  setShowAlert(true);
				  setAlertMessage(""+error);			
				  return false;
		  	})	
	}

  function hideAlert(){
		setShowAlert(false);
	}

  return (
    <>
      <Dialog fullWidth style={{margin:5}} maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-15px'}} onClose={handleClose}>Contacts</DialogTitle>
          <DialogContent >
            <Grid item md={12} xs={12}  >
                  
                  <Box mt={1} mb={1} >
                      <Grid container spacing={2}>
                        <Grid item md={12} xs={12} >
                          <FormControl style={{width:150,marginRight:60,float:'left'}}>
                            <OutlinedInput 
                            id="keywordtxt"
                            placeholder="Search"
                            value={keyword}
                            onChange={event => setKeyword(event.target.value)}
                            onKeyPress={(event)=>{onEnter(event)}}
                            style={{width:200,height:40}}
                            endAdornment={
                              <InputAdornment position="end">
                              <SearchIcon />
                              </InputAdornment>
                            }
                            />
                          </FormControl>
                          <Button onClick={() => {search()}} style={{marginTop:4,float:'left',backgroundColor:'#FFF',textTransform: 'none'}} size="small" variant="contained"  >Search</Button>
                        </Grid>
                      </Grid>
                  </Box>

                  <Box>
                    <Grid container spacing={2}>
                      <Grid item md={12} xs={12} >
                      {alphaArr.map((val,i)=>(	
                        <Button onClick={() => {handleAlphaFilter(val)}} style={alphaFilter===val?alphaBtnStyleActive:alphaBtnStyle} size="small" variant="outlined"  >{val}</Button>
                      ))}
                      </Grid>
                    </Grid>					
                  </Box>

                  <Box>

                  <div className="tblReport" style={{height: 350, width: '100%' }}>
                  <DataGrid
                    rows={rows}
                    columns={[
                      {
                        field: "Select",
                        headerName: "",
                        width: 90,
                        sortable: false,
                          renderCell: (cellValues) => {
                          return (
                            <Radio 
                            checked={cellValues.id === selectedRow}
                            value={cellValues.id}
                            name="radio-buttons"
                            inputProps={{ 'aria-label': {cellValues} }}
                            />
                           )
                          }
                        },
                      { field: 'id', headerName: '#', width: 40 },                         
                      { field: 'contactName', headerName: 'Contact Name', width: 170, renderCell: (params) =>  (
                        <Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
                         ), },	
                      { field: 'accountName', headerName: 'Account Name', width: 170, renderCell: (params) =>  (
                        <Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
                         ), },
                      { field: 'mobile', headerName: 'Mobile', width: 160},
                      { field: 'phone', headerName: 'Phone', width: 160 },				
                      { field: 'email', headerName: 'Email', width: 170, renderCell: (params) =>  (
                        <Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
                         ), },		  
                      { field: 'city', headerName: 'City', width: 160 },
                      { field: 'address', headerName: 'Address', width: 160 },
                      
                      ]}
                    pageSize={50}
                    rowHeight={40}
                    rowsPerPageOptions={[50]}
                    style={{fontSize:12}}	
                    onRowClick={itm => selectRow(itm)}			
                    components={{
                      NoRowsOverlay: () => (
                        <Stack height="100%" alignItems="center" justifyContent="center">
                        <span style={{color:'#FF0000',fontWeight:'bold'}}>No contacts found!</span>
                        </Stack>
                      )}}	
                  />
                  </div>
                  </Box>


                  
            </Grid>
          </DialogContent>
      </Dialog>


      <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>


    </>
  );

});

export default CustomizedDialogs;